<template>
  <div :id="componentId" class="sp-seven-year-wrapper">
    <div class="sp-seven-year">
      <img  class="year-icon" src="./images/year-icon.png" alt="" />
      <div class="year-background">
        <span class="year-text">{{ year }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpSevenYear',
  props: {
    yearText: {
      type: String,
      default: '2026 年'
    },
    componentId: {
      type: String,
      default: 'sp_seven_year'
    }
  },
  data() {
    return {
      year: this.yearText || '2026 年'
    }
  },
  watch: {
    yearText(newVal) {
      this.year = newVal
    }
  }
}
</script>

<style scoped>
.sp-seven-year-wrapper {
  position: relative;
  cursor: pointer;
  padding: 57px 0 0 0;
  min-height: 100px;
}

.sp-seven-year {
  display: flex;
  align-items: center;
  position: relative;
  max-width: 1400px;
  margin: 0 auto;
}

.year-icon {
  width: 34px;
  height: 45px;
}

.year-background {
  width: 160px;
  height: 58px;
  background-image: url('./images/year-background.png');
  background-size: contain;
  background-position: left center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
}

.year-text {
  width: 160px;
  height: 58px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 26px;
  color: #FFFFFF;
  letter-spacing: 1px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  line-height: 58px;
}
</style>
